export default "__VITE_ASSET__51b8517f__"